import script from "./SimpleLineChart1.vue?vue&type=script&setup=true&lang=ts"
export * from "./SimpleLineChart1.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__